import React, { useEffect, useRef, useState } from 'react';
import { getAppEnv } from '../../../config/env';
import { Context } from '../../AppContext';
import {
  setDeptAndReturnDateForMulticity,
  setCharDhamPackageUrl
} from '../../utils/timeUtils';
import { isMobile } from '../../utils/commonUtils';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const ScrollInView = ({
  windowRef,
  scrollerRef,
  component,
  dwebCardSizeInPx,
  dhamType
}: {
  windowRef: React.MutableRefObject<null>;
  scrollerRef: React.MutableRefObject<null>;
  component: JSX.Element;
  dwebCardSizeInPx: number;
  dhamType?: number | null;
}) => {
  const [isAtStart, setIsAtStart] = useState(true); // Controls if left arrow is disabled
  const [isAtEnd, setIsAtEnd] = useState(true); // Controls if right arrow is disabled
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  const isRightActive = () => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      const scrollerWidth = scrollerRef?.current?.offsetWidth;
      // @ts-ignore
      const windowWidth = windowRef?.current?.scrollWidth;
      // @ts-ignore
      const scrolledWidth = scrollerRef?.current?.scrollLeft;

      if (scrollerWidth + scrolledWidth < windowWidth) {
        return true;
      }
    }
    return false;
  };

  // for handling arrows on dham selection
  useEffect(() => {
    if (dhamType) {
      handleScroll();
    }
  }, [dhamType]);

  const modifyArrowState = () => {
    setTimeout(() => {
      try {
        // modify left arrow activity
        // @ts-ignore
        if (
          scrollerRef.current &&
          scrollerRef.current.scrollLeft &&
          scrollerRef.current.scrollLeft > 0
        ) {
          // @ts-ignore
          leftArrowRef.current.classList.add('active');
          // @ts-ignore
          leftArrowRef.current.classList.remove('inactive');
        } else {
          // @ts-ignore
          leftArrowRef.current.classList.remove('active');
          // @ts-ignore
          leftArrowRef.current.classList.add('inactive');
        }
      } catch (err) {
        console.log('erro');
      }
    }, 0);

    setTimeout(() => {
      try {
        if (isRightActive()) {
          // @ts-ignore
          rightArrowRef.current.classList.add('active');
          // @ts-ignore
          rightArrowRef.current.classList.remove('inactive');
        } else {
          // @ts-ignore
          rightArrowRef.current.classList.remove('active');
          // @ts-ignore
          rightArrowRef.current.classList.add('inactive');
        }
      } catch (err) {
        console.log('erro');
      }
    }, 0);
  };

  // Handle scroll event and update arrow states
  const handleScroll = () => {
    // @ts-ignore
    // console.log('refs',scrollerRef.current.offsetWidth, windowRef.current.scrollWidth,scrollerRef.current.scrollLeft)
    if (scrollerRef.current && windowRef.current) {
      // @ts-ignore
      const scrollerWidth = scrollerRef.current.offsetWidth;
      // @ts-ignore
      const windowWidth = windowRef.current.scrollWidth;
      // @ts-ignore
      const scrollLeft = scrollerRef.current.scrollLeft;

      // Update state of arrows based on scroll position
      setIsAtStart(windowWidth > scrollerWidth);
      setIsAtEnd(windowWidth > scrollerWidth);
    }
    modifyArrowState();
  };

  useEffect(() => {
    const scroller = scrollerRef.current;

    // Add scroll event listener on the horizontal scrolling container
    if (scroller) {
      // @ts-ignore
      scroller.addEventListener('scroll', handleScroll);
    }
    handleScroll();

    // Cleanup event listener on unmount
    return () => {
      if (scroller) {
        // @ts-ignore
        scroller.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const scrollHorizontalLeft = () => {
    // @ts-ignore
    if (scrollerRef?.current?.scrollLeft !== undefined) {
      // @ts-ignore
      scrollerRef.current.scrollBy({
        left: -dwebCardSizeInPx * 2, // Scroll left by two cards (660px per card)
        behavior: 'smooth' // Smooth transition
      });
    }
  };

  const scrollHorizontalRight = () => {
    // @ts-ignore
    if (scrollerRef?.current?.scrollLeft !== undefined) {
      // @ts-ignore
      scrollerRef.current.scrollBy({
        left: dwebCardSizeInPx * 2, // Scroll right by two cards
        behavior: 'smooth' // Smooth transition
      });
    }
  };

  return (
    <>
      <div style={{ position: 'relative', zIndex: 0 }} className="makeFlex">
        {isAtStart ? (
          <div
            ref={leftArrowRef}
            onClick={() => scrollHorizontalLeft()}
            className={`leftArrowMC desktopShow arrowMC`}
          ></div>
        ) : null}
        {component}
        {isAtEnd ? (
          <div
            onClick={() => scrollHorizontalRight()}
            ref={rightArrowRef}
            className={`rightArrowMC desktopShow arrowMC`}
          ></div>
        ) : null}
      </div>
    </>
  );
};

const MultiCityPackages = ({
  packages = [],
  disableStopFilter,
  disableCabCardImage,
  removeLeftRightPadding = false,
  stopType,
  packageListingUrl,
  viewCabsButtonUrl
}: {
  packages: any[];
  disableStopFilter: boolean;
  disableCabCardImage: boolean;
  removeLeftRightPadding: boolean;
  stopType: string;
  packageListingUrl?: string;
  viewCabsButtonUrl?: string;
}) => {
  const { omniUrlArgs, trackTemplateEvent } = React.useContext(Context);
  const initCab = () => {
    if (
      packages &&
      packages
        .map((pkg: any) => pkg?.cab_type)
        .filter(pkg => pkg)
        .includes('Sedan')
    ) {
      return 'Sedan';
    } else {
      return 'SUV';
    }
  };

  const initDham = () => {
    return disableStopFilter
      ? null
      : Math.min(...packages.map((pkg: any) => pkg?.dham));
  };

  const [cabType, setCabType] = useState(initCab());
  const [dhamType, setDham] = useState(initDham());
  const scrollerRef = useRef(null);
  const windowRef = useRef(null);

  const getImageUrl = imageName => {
    return `${PUBLIC_URL}/static/public/${imageName}`;
  };

  const getDham = () => {
    return Array.from(new Set(packages.map(({ dham }) => `${dham}`))).sort();
  };

  const getCabType = () => {
    return Array.from(
      new Set(
        packages
          .filter(({ dham }) => dhamType === dham)
          .map(({ cab_type }) => `${cab_type}`)
          .filter(
            cab_type =>
              String(cab_type).toUpperCase() == 'SUV' ||
              String(cab_type).toUpperCase() == 'SEDAN'
          )
      )
    );
  };

  useEffect(() => {
    // Avoid unnecessary state updates to prevent flickering
    setCabType(prevCabType => {
      const newCabType = getDhamTypeAvailableCabType(dhamType);
      return newCabType !== prevCabType ? newCabType : prevCabType;
    });
  }, [dhamType]);

  const getDhamTypeAvailableCabType = dhamType => {
    // Select Sedan if available, else SUV
    const dhamTypeCab = packages.filter((pkg: any) => pkg?.dham === dhamType);
    if (dhamTypeCab.length > 0) {
      return dhamTypeCab.some((pkg: any) => pkg?.cab_type === 'Sedan')
        ? 'Sedan'
        : 'SUV';
    }
    return 'SUV';
  };

  const isSEODetailPageRedirection = (url: string) => {
    if (url && url.toUpperCase().includes('SEO_MULTICITY_TEMPLATE_V2')) {
      return true;
    }
    return false;
  };
  return (
    <div
      className={`mcPackageSelector ${
        removeLeftRightPadding ? '' : 'leftRightPadding'
      }`}
    >
      <div className="selectors">
        {dhamType ? (
          <div className="dhamSelectorContainer">
            <div className="dhamSelector">
              {getDham().map(dham => (
                <div
                  key={`dham_${dham}`}
                  onClick={() => {
                    trackTemplateEvent(`Dham_selected_${dham}`);
                    setDham(Number(dham));
                  }}
                  className={`dhamButton  ${
                    Number(dham) === dhamType ? 'selected' : ''
                  }`}
                >
                  {dham} {stopType}
                </div>
              ))}
            </div>
          </div>
        ) : null}
        <div className="cabTypeSelector">
          {(() => {
            const cabTypes = getCabType();
            if (cabTypes.length < 2) {
              return null;
            }

            return cabTypes.map((cabtype, idx) => (
              <div
                key={`cab_${cabtype}`}
                onClick={() => {
                  trackTemplateEvent(`Cab_Type_selected_${cabtype}`);
                  setCabType(cabtype);
                }}
                className={`cabButton makeFlex alignCenter latoBold font18 ${
                  cabtype === cabType ? 'selected' : ''
                } ${idx == 0 ? 'appendRight5' : ''}`}
              >
                <img
                  className="cabTypeImage"
                  style={{ width: 53, margin: '5px' }}
                  src={`${PUBLIC_URL}/static/public/${cabtype.toLowerCase()}.png`}
                />
                <div className="cabInfo">
                  <div className="cabType">{cabtype}</div>
                  <div className="seater">
                    {cabtype === 'SUV' ? `6 seater` : `4 seater`}
                  </div>
                </div>
                <img
                  style={{
                    display: cabtype === cabType ? 'block' : 'none',
                    width: '20px',
                    height: '20px'
                  }}
                  className="checkBoxImage"
                  src={`${PUBLIC_URL}/static/public/checkbox3.png`}
                />
              </div>
            ));
          })()}
        </div>
      </div>
      <ScrollInView
        dhamType={dhamType}
        windowRef={windowRef}
        scrollerRef={scrollerRef}
        dwebCardSizeInPx={345}
        component={
          <div ref={scrollerRef} className="mcPackageScroller perfectCenter ">
            <div
              ref={windowRef}
              className={`justifyAtStart makeFlex mcPackageWindow`}
            >
              {packages.map(
                (
                  {
                    title,
                    dham,
                    dham_included,
                    cab_type,
                    source,
                    destination,
                    duration,
                    durationInDays,
                    price_text,
                    price_text_sub,
                    stops = [],
                    dweb_url,
                    mobile_url,
                    img
                  },
                  idx
                ) => {
                  return cab_type == cabType &&
                    ((dhamType && dham == dhamType) || !dhamType) ? (
                    <div
                      key={`pkg_${idx}_${dham}_${cab_type}_${title}`}
                      onClick={() => {
                        let url;
                        if (packageListingUrl || viewCabsButtonUrl) {
                          url = setCharDhamPackageUrl(
                            packageListingUrl || viewCabsButtonUrl || '',
                            2
                          );
                        } else {
                          url = isMobile()
                            ? setDeptAndReturnDateForMulticity(
                                mobile_url,
                                3,
                                duration
                              )
                            : setDeptAndReturnDateForMulticity(
                                dweb_url,
                                3,
                                duration
                              );
                        }
                        trackTemplateEvent(
                          `View_Cab_Click_${cabType}_${dhamType}_${title}`
                        );
                        const seoToDetailPage = isSEODetailPageRedirection(url);
                        if (seoToDetailPage) {
                          trackTemplateEvent(
                            `View_Cab_Click_${cabType}_${dhamType}_${title}_Seo_To_Detail`
                          );
                        }
                        window.location = Object(url);
                      }}
                      style={{ minWidth: '226px' }}
                      className={`card`}
                    >
                      <div className="cardinfo">
                        {disableCabCardImage ? null : (
                          <div className="mcPackageImage">
                            <img
                              className="mcPackageImage"
                              style={{ width: 210, height: 139 }}
                              src={getImageUrl(img)}
                            />
                          </div>
                        )}

                        <div className="title fulWidth">
                          <div className="mcTitle pushLeft appendRight8">
                            {title}
                          </div>
                          <div className="duration">{durationInDays}</div>
                        </div>

                        <div className="dham">
                          <div>
                            <div className="makeFlex vrtlCenter2">
                              <img
                                width={20}
                                height={20}
                                src={`${PUBLIC_URL}/static/public/location-pin.webp`}
                              />
                              <div className="dhamText greyishTxt">
                                {source}
                              </div>
                            </div>
                            {stops &&
                              stops.length > 0 &&
                              stops.map(stop => (
                                <div
                                  key={`stop_${stop}`}
                                  className="makeFlex vrtlCenter2"
                                >
                                  <img
                                    width={20}
                                    height={20}
                                    src={`${PUBLIC_URL}/static/public/location-dot.png`}
                                  />
                                  <div
                                    style={{
                                      fontWeight: dham_included[stop]
                                        ? 900
                                        : 400
                                    }}
                                    className={`stopText blackText`}
                                  >
                                    {stop}
                                  </div>
                                </div>
                              ))}
                            <div className="makeFlex vrtlCenter2">
                              <img
                                width={20}
                                height={20}
                                src={`${PUBLIC_URL}/static/public/location-pin.webp`}
                              />
                              <div className="dhamText greyishTxt">
                                {destination}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pushBottom">
                          <div className="dottedHorizontalLine appendTop10 appendBottom10"></div>
                          <div className="bookCab spaceBetween">
                            <div className="bookCabStyle appendRight5">
                              <div className="priceTextSup appendRight5">
                                <span>{price_text_sub}</span>
                              </div>
                              <div className="price">
                                <span className="blackText latoBlack priceText">
                                  {price_text}
                                </span>
                                <span className="desktopShow cabTypeText">{`for ${cab_type}`}</span>
                              </div>
                            </div>
                            <div className="viewCab makeFlex perfectCenter">
                              <span>{'View Cabs'}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null;
                }
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default MultiCityPackages;
